import { ProjectRepeatPeriod } from "../projects/ProjectRepeatPeriod";
import { GoalType } from "../projects/GoalType";
import { ChannelCostType } from "./ChannelCostType";
import { ChannelType } from "./ChannelType";
import { CampaignStatus } from "./CampaignStatus";

export interface CampaignGridView {
  ChannelId: number;
  CompanyId?: number;
  PhoneId?: number;

  Active: boolean;
  AlertsCount: number;
  AllAssetsExternalApi: boolean;
  AverageClickCost: number;
  AverageImpressionCost: number;
  AverageLeadCost: number;
  AverageViewCost: number;
  AverageVisitorCost: number;
  AvgCostTemplate: string;
  Budget: number;
  BudgetMedia?: number;
  BudgetString: string;
  BudgetToolTip: string;
  BudgetWeather?: number;
  CrmName: string;
  CTR: number;
  CallsCount?: number;
  ChannelType: ChannelType;
  ChannelTypeId: number;
  ChannelTypeString: string;
  ChannelStatus: CampaignStatus;
  ChannelTitle: string;
  ClickCount?: number;
  ClicksOrViews: number;
  ClicksToLeads: number;
  CompanyLeadAveragePrice: number;
  CompanyTitle: string;
  GoalRepeatPeriodId: ProjectRepeatPeriod;
  GoalTypeId: GoalType;
  Projects: string;
  Connected: boolean;
  Conversion: number;
  Cost?: number;
  CostTypeHumanize: ChannelCostType;
  GoalCostTypeId: number;
  CurrentGoal: number;
  DailyGoal: number;
  Days: number;
  DealAmount?: number;
  DealCount?: number;
  DefaultAssetTitle: string;
  DefaultAssetUrl: string;
  EnableCRM: boolean;
  GoalEndDate?: Date;
  ExpectedBudget: number;
  ExpectedGoal: number;
  ExternalTokenInvalidUpdateTime?: Date;
  ExternalTokenValid: boolean;
  FbOptimizationGoal: string;
  FbPlacements: string;
  Frequency: number;
  Goal: number;
  GoalString: string;
  GoalToolTip: string;
  GoalWeather?: number;
  ImpressionCount?: number;
  Impressions1kPrice: number;
  IsAutoCreated: boolean;
  LeadCount?: number;
  LeadsToMeetings: number;
  MeetingCount?: number;
  MeetingsToDeals: number;
  DeactivationDate?: Date;
  Phone: string;
  RedirectPhone: string;
  SMSNumber: string;
  GoalStartDate?: Date;
  StatusStr: string;
  TokenValid: boolean;
  TokenValidUpdateTime?: Date;
  TotalWeather?: number;
  ViewCount?: number;
  VisitorCount?: number;
  VisitorRate: number;
  WhatsAppPhone: string;

  // not mapped properties
  Color?: string;
}

export enum RefreshGridMode {
  None,
  Full,
  GraphsOnly,
  GridOnly,
}
